import * as Polyfill from '../../components/polyfill';

import { SignUp } from './page';


Polyfill.init();

new SignUp(document.querySelector('body')).init();